<template>
  <transition name="popup">
    <div class="popup-back">
      <section class="popup defend-pop-wrap dark-theme">
        <h1 class="popup-title">{{ title }} 팝업</h1>
        <div class="popup-button-close">
          <button type="button" @click.prevent="$emit('on-click-close')">
            <img
              :src="require('@/assets/images/common/btn-popup-close.svg')"
              alt="팝업 닫기"
            />
          </button>
        </div>

        <div class="pop-contents tAc">
          <h1>{{ title }}</h1>
          <span class="pop-txt" v-html="descriptionRendered"></span>
          <slot name="content"></slot>

          <div class="button-area tAc">
            <div class="btn-gray-line button-cover">
              <button type="button" @click.prevent="$emit('on-click-close')">
                <slot name="close">취소</slot>
              </button>
            </div>
            <div class="btn-submit button-cover">
              <button type="button" @click.prevent="$emit('on-click-submit')">
                <slot name="confirm">확인</slot>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  const props = defineProps({
    title: {
      type: String,
      default: '',
      required: true,
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
  })

  const descriptionRendered = computed(() => {
    return props.description.replaceAll('\n', '<br />')
  })
</script>
<style scope src="@/assets/css/mypooq.css"></style>
<style scoped lang="scss">
  .button-area {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 40px;
    .button-cover {
      display: block;
      width: 130px;
      height: 48px;
      border: 1px solid #5e5e5e;
      border-radius: 30px;
      &.btn-gray-line {
        background-color: #5e5e5e;
      }
      &.btn-submit {
        background-color: #0050ff;
        border-color: #0050ff;
      }
      > button {
        display: block;
        padding: 12px 0;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 16px;
      }
    }
  }
</style>
